const BASE_API = Object.freeze({
  AFFILIATE_EXPERIENCE: process.env.VUE_APP_BASE_URL_AFFILIATE_EXPERIENCE + process.env.VUE_APP_API_PATH_AFFILIATE_EXPERIENCE,
});
export default BASE_API;